import React from "react";

function SapBpr() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb5">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Business Process Re-engineering
          </h4>
        </div>
      </div>

      {/* Body Section Start */}
      <div className="container py-5">
        <section className="wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center g-5">
            {/* Image Section */}
            <div className="col-lg-6 col-md-12">
              <img
                src="assets/img/processEngineering.jpg"
                alt="Business Process Re-engineering"
                className="img-fluid rounded-4 shadow-lg"
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Text Section */}
            <div className="col-lg-6 col-md-12">
              <div className="section-title">
                <h2 className="fw-bold text-primary mb-3">
                  Revitalize, Transform, Thrive
                </h2>
                <p>
                  Our <strong>Business Process Re-engineering (BPR)</strong>{" "}
                  service offers your business a strategic approach aimed at
                  redesigning and improving business processes within your
                  organization.
                </p>
                <p>
                  Our service will help your business achieve significant
                  enhancements in efficiency, effectiveness, and overall
                  performance of your business processes. With our expertise,
                  your organization can gain the following benefits:
                </p>

                <ul className="list-unstyled ms-3">
                  <li> Streamlined & efficient processes</li>
                  <li> Cost Savings from eliminating redundant activities</li>
                  <li> Greater Process Flexibility and Agility</li>
                  <li> Improved Product Quality</li>
                  <li> Alignment of business processes with strategic goals</li>
                  <li> Faster Time-to-Market</li>
                  <li> Employee Empowerment and Morale</li>
                  <li> Enhanced Communication and Collaboration</li>
                  <li> Data-Driven Decision Making</li>
                </ul>

                <p className="mt-3">
                  While the benefits of Business Process Re-engineering can be
                  significant, it's important to note that successful
                  implementation requires careful planning, stakeholder
                  involvement, and ongoing monitoring and adjustment.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Mobile Image Adjustment */}
      <style>
        {`
          @media (max-width: 768px) {
            img[alt="Business Process Re-engineering"] {
              max-height: 350px !important;
            }
          }
        `}
      </style>
    </>
  );
}

export default SapBpr;
